export const COINBASE_BLUE = '#0052FF';
